import React from 'react';

const s = {
  h1: { fontSize: 24, fontWeight: 700, marginBottom: 24 },
  h2: { fontSize: 16, fontWeight: 700, marginTop: 28, marginBottom: 8 },
  p: { color: '#ccc', fontSize: 14, lineHeight: 1.7, marginBottom: 8 },
  card: { background: '#1a1a1a', borderRadius: 8, padding: 32, maxWidth: 680 },
};

export default function PrivacyPage() {
  return (
    <div>
      <h1 style={s.h1}>Privacy Policy</h1>
      <div style={s.card}>
        <p style={s.p}>
          This policy explains what personal data Bryggeriet Ångkvarn collects through the
          F1 Tips prediction pool and separate event raffles, and how it is used.
        </p>

        <h2 style={s.h2}>What we collect</h2>
        <p style={s.p}>
          When you submit a race prediction we collect your <strong>display name</strong> and
          <strong> email address</strong>. Your predictions are also stored alongside this information.
        </p>

        <h2 style={s.h2}>How we use it</h2>
        <p style={s.p}>
          <strong>Display name</strong> — shown publicly in race entry lists and leaderboards so
          participants can follow the standings.
        </p>
        <p style={s.p}>
          <strong>Email address</strong> — used only to send you exclusive information about
          Bryggeriet Ångkvarn events. It is never shared with third parties or shown publicly.
        </p>

        <h2 style={s.h2}>Event raffles (separate from F1 predictions)</h2>
        <p style={s.p}>
          If you enter an event raffle, we collect the display name and email you provide
          to register one entry per email, manage the draw and contact the winner.
          Your email is not displayed on the public entry page or venue screen, is not
          added to any marketing list, and is not used to send promotional emails.
          The winning display name may be shown on a venue screen.
        </p>
        <p style={s.p}>
          Raffle data is separate from race predictions. Organisers can manually delete
          a raffle and all associated entries and results after prize follow-up;
          the target is within 30 days. This is not yet automatic. To request
          access or deletion, contact us using the address below.
        </p>

        <h2 style={s.h2}>Local storage</h2>
        <p style={s.p}>
          Your display name is saved in your browser's local storage so you can be recognised
          on return visits without logging in. No cookies are used. You can clear this at any
          time by clearing your browser's site data.
        </p>

        <h2 style={s.h2}>Data retention</h2>
        <p style={s.p}>
          Your data is kept for the duration of the active season and may be retained for
          historical records. If you wish to have your data removed, contact us and we will
          delete your entries.
        </p>

        <h2 style={s.h2}>Your rights</h2>
        <p style={s.p}>
          Under GDPR you have the right to access, correct, or erase your personal data.
          To exercise these rights, email us at{' '}
          <a href="mailto:info@bryggerietangkvarn.se" style={{ color: '#f9b000' }}>
            info@bryggerietangkvarn.se
          </a>{' '}
          and we will handle your request promptly.
        </p>

        <h2 style={s.h2}>Data controller</h2>
        <p style={s.p}>
          Bryggeriet Ångkvarn is the data controller for information collected through this
          application. Contact:{' '}
          <a href="mailto:info@bryggerietangkvarn.se" style={{ color: '#f9b000' }}>
            info@bryggerietangkvarn.se
          </a>
        </p>

        <p style={{ ...s.p, marginTop: 24, color: '#666', fontSize: 13 }}>
          Last updated: November 2026
        </p>
      </div>
    </div>
  );
}
